<article class="message-card" [attr.aria-labelledby]="titleId">
    <span *ngIf="header" class="message-card-header">{{header}}</span>
    <div class="message-card-head">
        <span class="message-card-mark" aria-hidden="true"><i [ngClass]="icon"></i></span>
        <div class="message-card-text">
            <span [id]="titleId" class="message-card-title">{{card.title}}</span>
            <span class="message-card-meta">
                <span *ngIf="card.live" class="message-card-live" aria-hidden="true"></span>
                <span class="message-card-meta-text">{{card.meta}}</span>
            </span>
        </div>
    </div>
    <div class="message-card-actions" *ngIf="card.action">
        <button mat-flat-button color="primary" type="button" (click)="open()">{{card.action.label}}</button>
    </div>
</article>
